import { render } from "./SplitOrderModal.vue?vue&type=template&id=a8f263da&scoped=true"
import script from "./SplitOrderModal.vue?vue&type=script&lang=js"
export * from "./SplitOrderModal.vue?vue&type=script&lang=js"

import "./SplitOrderModal.vue?vue&type=style&index=0&id=a8f263da&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8f263da"]])

export default __exports__